import numberUtils from 'app-lib/numberUtils'
import { observer } from 'mobx-react'
import React from 'react'
import StatsVM from '../StatsVM'

export function StatsTotal({ vm }: { vm: StatsVM }) {
  const currentChainAllTokensStats = vm.selectedChainAllTokensStats
  const { usdTotalLocked, usdSupply } = currentChainAllTokensStats
  return (
    <div className="reserve__grid-totals margin-bottom-2">
      <div className="panel--simple padded-1">
        <div className="txt-muted margin-bottom-1">Total Value Locked (USD)</div>
        <b title={usdTotalLocked ? `$${usdTotalLocked}` : ``}>
          {usdTotalLocked ? (
            <div>
              <span className="txt-muted">$</span>
              {numberUtils.autoFormat(usdTotalLocked)}
            </div>
          ) : (
            `-`
          )}
        </b>
      </div>
      <div className="panel--simple padded-1">
        <div className="txt-muted margin-bottom-1">Total Supply (USD)</div>
        <b title={usdSupply ? `${usdSupply}` : ``}>
          {usdSupply ? (
            <div>
              <span className="txt-muted">$</span>
              {numberUtils.autoFormat(usdSupply)}
            </div>
          ) : (
            `-`
          )}
        </b>
      </div>
    </div>
  )
}

export default observer(StatsTotal)
